// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__MIm5e","vLegacy":"SelectSecondary_vLegacy__1HhFg","error":"SelectSecondary_error__3E_my","disabled":"SelectSecondary_disabled__2-_ic"};